import MatchHeight from 'vanilla-js-match-height';

export default function Heights() {
	// Create new instances of MatchHeight for different elements
	// Each instance will ensure that elements with the same class have the same height

	new MatchHeight('.js-product-name'); // Match heights of elements with the class 'js-product-name'
	new MatchHeight('.js-product-price'); // Match heights of elements with the class 'js-product-price'
	new MatchHeight('.js-product-card'); // Match heights of elements with the class 'js-product-card'
	new MatchHeight('.js-post-heading'); // Match heights of elements with the class 'js-post-heading'
	new MatchHeight('.js-banner-heading'); // Match heights of elements with the class 'js-banner-heading'
	new MatchHeight('.js-banner-content'); // Match heights of elements with the class 'js-banner-content'
	new MatchHeight('.js-card-title'); // Match heights of elements with the class 'js-card-title'
	new MatchHeight('.js-card-content');
	new MatchHeight('.js-testimonial-content', { timeOut: 200 });
	new MatchHeight('.js-testimonial-heading', { timeOut: 200 });
	new MatchHeight('.js-news-heading', { timeOut: 200, byRow: false });
}
